import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    page: String,
    generatingTranslation: String,
    livePreviewPollUrl: String,
    stepsMapping: String,
    mode: String,
    sortable: { type: Boolean, default: false },
    previewPolls: { type: Array, default: [] },
    unpersistedPreviewUrl: String,
  }

  connect() {
    this.waitForSecureDashboard((sd) => this.setupSecureDashboard(sd))
  }

  waitForSecureDashboard(done, attempts = 0) {
    const sd = window.App?.SecureDashboard
    if (sd) {
      done(sd)
      return
    }
    if (attempts < 100) {
      requestAnimationFrame(() => this.waitForSecureDashboard(done, attempts + 1))
    }
  }

  setupSecureDashboard(sd) {
    if (this.pageValue === 'form') {
      sd.initialize({
        generating_translation: this.generatingTranslationValue,
        live_preview_poll_url: this.livePreviewPollUrlValue,
      })
      const mapping = this.stepsMappingValue ? JSON.parse(this.stepsMappingValue) : []
      sd.form.onFormLoadCreateSteps(this.modeValue, mapping)
      if (this.sortableValue) sd.form.initSortable()
      sd.form.initCocoonCallback()
    } else if (this.pageValue === 'index') {
      sd.initialize({})
      this.previewPollsValue.forEach((poll) => {
        sd.preview.pollGeneratingProgress(String(poll.id), poll.url)
      })
    }
  }

  onStepChange(event) {
    window.App?.SecureDashboard?.form.onStepChange(event.currentTarget)
  }

  removeStep(event) {
    event.preventDefault()
    window.App?.SecureDashboard?.form.removeStep(event.currentTarget)
  }

  generateUnpersistedPreview(event) {
    event.preventDefault()
    const sd = window.App?.SecureDashboard
    if (!sd || !this.hasUnpersistedPreviewUrlValue) return
    sd.livePreview.generateUnpersistedPreview(this.unpersistedPreviewUrlValue)
  }
}
